import { render, staticRenderFns } from "./NormalAchievement.vue?vue&type=template&id=45999cdd&scoped=true&"
import script from "./NormalAchievement.vue?vue&type=script&lang=js&"
export * from "./NormalAchievement.vue?vue&type=script&lang=js&"
import style0 from "./NormalAchievement.vue?vue&type=style&index=0&id=45999cdd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45999cdd",
  null
  
)

export default component.exports